/*
 * 制作風景の背景の出し入れ
 *
 * 背景は position: fixed の層（.iroiro-production__bg）で止めている。
 * background-attachment: fixed を使わないのは、iOS がそれをまともに
 * 扱えないため。position: fixed なら iOS でも効く。
 *
 * ただし fixed の要素は画面に貼り付くので、放っておくと
 * セクションが画面外にあるときも出たままになり、
 * 重ね順で下に来るもの（ページ上部のヒーローなど）を覆ってしまう。
 * そこでセクションが画面外に出たら消す。
 *
 * 担当するのは「消す」側だけ。CSS の既定を「表示」にしてあるので、
 * この JS が動かなくても背景は出る。逆向き（JSで出す）にすると、
 * 動かなかったときに地色のグレーだけが残ってしまう。
 *
 * 旧テーマはスクロールのたびに位置を計算していたが、
 * ここでは出入りの瞬間だけ発火する IntersectionObserver を使う。
 * スクロール中に毎フレーム測ることがないので軽い。
 */
(function () {
  'use strict';

  var SELECTOR = '[data-iroiro-production]';
  var HIDDEN = 'is-bg-hidden';

  var observer = null;

  function observerInstance() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle(HIDDEN, !entry.isIntersecting);
      });
    });
    return observer;
  }

  function collect(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.iroiroProductionReady === 'true') return;
      el.dataset.iroiroProductionReady = 'true';

      /*
       * IntersectionObserver が使えない環境では何もしない。
       * CSS の既定が「表示」なので、そのまま出したままになる。
       */
      if (!('IntersectionObserver' in window)) return;

      observerInstance().observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      collect(document);
    });
  } else {
    collect(document);
  }

  // テーマエディタでの編集に追従する
  document.addEventListener('shopify:section:load', function (event) {
    collect(event.target);
  });
})();
